// extracted by mini-css-extract-plugin
module.exports = {"main-component":"userProfile_main-component__39Dyz"};